/**
 * Cyberpunk cards — mouse tilt + ambilight; mobile GIF poster swap.
 */
(function () {
  const REDUCE_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
  const FINE_POINTER = window.matchMedia('(hover: hover) and (pointer: fine)');
  const GIF_VIEWPORT = window.matchMedia('(max-width: 989px)');

  function resetTilt(card, ambi) {
    if (card) card.style.transform = '';
    if (ambi) {
      ambi.style.transform = '';
      ambi.style.animationPlayState = '';
    }
  }

  function shouldLoadMobileGif() {
    return GIF_VIEWPORT.matches && !REDUCE_MOTION.matches;
  }

  function revealGif(img) {
    img.classList.add('is-loaded');
    const item = img.closest('.cp-cards__item');
    if (item) item.classList.add('cp-cards__item--gif-ready');
  }

  function preloadGif(src) {
    return fetch(src, { mode: 'cors' })
      .then(function (res) {
        if (!res.ok) throw new Error('gif fetch failed');
        return res.blob();
      })
      .then(function (blob) {
        return URL.createObjectURL(blob);
      })
      .catch(function () {
        return new Promise(function (resolve, reject) {
          const pre = new Image();
          pre.onload = function () {
            resolve(src);
          };
          pre.onerror = reject;
          pre.src = src;
        });
      });
  }

  function startGifsTogether(entries) {
    requestAnimationFrame(function () {
      entries.forEach(function (entry) {
        entry.img.src = entry.url;
      });
      entries.forEach(function (entry) {
        revealGif(entry.img);
      });
    });
  }

  function loadGifsTogether(scope) {
    const imgs = Array.prototype.slice
      .call(scope.querySelectorAll('[data-cp-product-gif]'))
      .filter(function (img) {
        return img.dataset.gifBound !== 'true' && img.getAttribute('data-src');
      });

    if (!imgs.length) return;

    imgs.forEach(function (img) {
      img.dataset.gifBound = 'true';
    });

    const load = function () {
      Promise.all(
        imgs.map(function (img) {
          return preloadGif(img.getAttribute('data-src')).then(
            function (url) {
              return { img: img, url: url };
            },
            function () {
              return null;
            }
          );
        })
      ).then(function (results) {
        startGifsTogether(results.filter(Boolean));
      });
    };

    if (shouldLoadMobileGif()) {
      load();
      return;
    }

    const onChange = function () {
      if (shouldLoadMobileGif()) {
        GIF_VIEWPORT.removeEventListener('change', onChange);
        load();
      }
    };
    GIF_VIEWPORT.addEventListener('change', onChange);
  }

  function bindCard(visual) {
    if (visual.dataset.tiltBound === 'true') return;
    visual.dataset.tiltBound = 'true';

    const card = visual.querySelector('[data-cp-tilt-card]');
    const ambi = visual.querySelector('.cp-cards__ambilight');
    if (!card) return;

    let leaveTimer;

    const onMove = (event) => {
      if (REDUCE_MOTION.matches || !FINE_POINTER.matches) return;

      const rect = card.getBoundingClientRect();
      if (!rect.width || !rect.height) return;

      const x = (event.clientX - rect.left) / rect.width;
      const y = (event.clientY - rect.top) / rect.height;
      const rotY = (x - 0.5) * 20;
      const rotX = (0.5 - y) * 20;

      card.style.transform =
        'perspective(800px) rotateX(' +
        rotX +
        'deg) rotateY(' +
        rotY +
        'deg) scale3d(1.04, 1.04, 1.04)';
      card.style.setProperty('--shine-x', x * 100 + '%');
      card.style.setProperty('--shine-y', y * 100 + '%');

      if (ambi) {
        const mx = (x - 0.5) * 24;
        const my = (y - 0.5) * 24;
        ambi.style.transform =
          'translate(calc(-50% + ' + mx + 'px), calc(-50% + ' + my + 'px)) scale(1.25)';
        ambi.style.animationPlayState = 'paused';
      }
    };

    const onEnter = () => {
      if (REDUCE_MOTION.matches || !FINE_POINTER.matches) return;
      clearTimeout(leaveTimer);
      visual.classList.add('is-hover');
    };

    const onLeave = () => {
      leaveTimer = setTimeout(function () {
        visual.classList.remove('is-hover');
        resetTilt(card, ambi);
      }, 80);
    };

    card.addEventListener('mousemove', onMove);
    card.addEventListener('mouseenter', onEnter);
    card.addEventListener('mouseleave', onLeave);
  }

  function init(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-cp-tilt-wrap]').forEach(bindCard);
    loadGifsTogether(scope);
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
